import { ADD_TTP_INFO } from "./ttpInfoReducer"

export const addTtpInfo = (obj) => ({
    type: ADD_TTP_INFO,
    payload: obj
})